module.exports = __webpack_public_path__ + "static/media/transit.a4b4e957.png";